<div ngbDropdown
	#warrantyDrop="ngbDropdown"
	class="d-inline-block dropdown-content"
	*ngIf="warrantyData && warrantyData.info && (warrantyData.info.status === 0 || warrantyData.info.status === 1)">
	<div class="dropdown-btn"
		id="header-warranty-icon"
		tabindex="1"
		attr.aria-label="lenovo warranty status: {{ warrantyData.info.status == 0 ? 'in warranty' : 'warranty expired'}}"
		(keyup.enter)="$event.stopPropagation(); warrantyDrop.open();"
		ngbDropdownToggle>
		<div class="icon-con in-warranty"
			*ngIf="warrantyData.info.status === 0">
			<fa-icon [icon]="['fas', 'check']"></fa-icon>
		</div>
		<div class="icon-con"
			*ngIf="warrantyData.info.status === 1">
			<fa-icon [icon]="['fas', 'exclamation']"></fa-icon>
		</div>
	</div>
	<div class="header-warranty-dropdown"
		[class.in-warranty]="warrantyData.info.status === 0"
		[class.expired]="warrantyData.info.status === 1"
		ngbDropdownMenu
		aria-labelledby="header-warranty-icon">
		<div class="position-top"></div>
		<div class="menu-pointer"></div>
		<div class="dropdown-item"
			ngbDropdownItem>
			<div class="title pb-3"
				*ngIf="warrantyData.info.status === 0"
				id="in-warranty-title"
				attr.aria-label="in-warranty-title">
				{{'support.warranty.titleInWarranty' | translate}}
			</div>
			<div class="title pb-3"
				*ngIf="warrantyData.info.status === 1"
				id="expired-warranty-title"
				attr.aria-label="expired-warranty-title">
				{{'support.warranty.titleWarrantyExpired' | translate}}
			</div>

			<div class="sub-description pb-4">
				<div class="pb-1"
					id="warranty-start-date"
					attr.aria-label="warranty-start-date">
					{{'support.warranty.startDate' | translate}}<b>{{ warrantyData.info.startDate | formatLocaleDate }}</b>
				</div>
				<div id="warranty-end-date"
					attr.aria-label="warranty-end-date">
					{{'support.warranty.endDate' | translate}}<b>{{ warrantyData.info.endDate | formatLocaleDate }}</b>
				</div>
			</div>

			<div class="button-box">
				<vtr-ui-button linkId="btn-header-warranty-options"
					[tabIndex]="1"
					buttonColor="gray"
					[isFullWidth]="true"
					[btnHeight]="true"
					[inRedBackground]="warrantyData.info.status==1"
					[label]="'support.warranty.viewWarrantyOptions' | translate"
					[href]="warrantyData.info.url"></vtr-ui-button>
			</div>
		</div>
	</div>
</div>
